var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"reveal-corner","appear":""}},[(_vm.offline)?_c('div',{staticClass:"disconnected"},[_c('Disconnected')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }